import { FC } from "react";
import { Anchor } from "@/components/Header/Anchor/Anchor";
import { Section } from "@/components/Html/Section";
import { Title } from "../Title/Title";
import { Card } from "./Card/Card";

interface Props {
  title: string;
  cards: { title: string; description: string }[];
}

export const Services: FC<Props> = ({ cards, title }) => {
  return (
    <Section className="kdot-container mx-auto my-[48px]">
      <Anchor id="services" />
      <Title className="text-[32px] md:text-[2.5rem]" title={title} />

      <Section className="flex flex-wrap gap-x-[16px] gap-y-[32px]">
        {cards.map((card) => (
          <Card key={card.title} title={card.title} description={card.description} />
        ))}
      </Section>
    </Section>
  );
};
